import React, { useState } from "react";
import { emssData, icligmData, saasData, cloudData, iclreactData, iclCBData } from "./about";
import { Helmet } from "react-helmet";

export const Features = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const apiMap = {
    EMSS: emssData,
    ICLIGM: icligmData,
    SaaS: saasData,
    Cloud: cloudData,
    "ICL Reacts": iclreactData,
    "ICL ChatBot": iclCBData
  };
  const featureDetails = props.apiData || apiMap;
  const features = Array.isArray(props.data) ? props.data : [];

  return (
    <>
      <div id="features" className="text-center">
        {props.isStandalone && (
        <Helmet htmlAttributes={{ lang: "en" }}>
          <title>Features | EMSS, ICLIGM & AI Solutions | ICL Software Solutions</title>

          <link rel="canonical" href="https://eximon.com/features/" />

          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Explore the key features of ICL software solutions, including EMSS, ICLIGM, SaaS cloud services, and AI-powered chatbot solutions for maritime shipping, logistics, and international trade."
          />

          {/* Open Graph */}
          <meta property="og:title" content="Features | EMSS, ICLIGM & AI Solutions | ICL Software Solutions" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://eximon.com/features/" />
          <meta
            property="og:description"
            content="Explore the key features of ICL software solutions, including EMSS, ICLIGM, SaaS cloud services, and AI-powered chatbot solutions for maritime shipping, logistics, and international trade."
          />
          <meta property="og:image" content="https://eximon.com/img/apple-touch-icon.png" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Features | EMSS, ICLIGM & AI Solutions | ICL Software Solutions" />
          <meta
            name="twitter:description"
            content="Explore the key features of ICL software solutions, including EMSS, ICLIGM, SaaS cloud services, and AI-powered chatbot solutions for maritime shipping, logistics, and international trade."
          />
          <meta name="twitter:image" content="https://eximon.com/img/apple-touch-icon.png" />
            <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://eximon.com/features",
          "name": "Features - ICL Software Solutions",
          "url": "https://eximon.com/features",
          "applicationCategory": "BusinessApplication",
          "operatingSystem": "Web",
          "description":
            "Explore the key features of ICL software solutions, including EMSS, ICLIGM, SaaS cloud services, and AI-powered chatbot solutions for maritime shipping, logistics, and international trade.",
          "inLanguage": "en",
          "provider": {
            "@type": "Organization",
            "name": "ICL Software Solutions",
            "url": "https://eximon.com/"
          },
          "isPartOf": {
          "@id": "https://eximon.com/"
        }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://eximon.com/features#breadcrumb",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://eximon.com/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Features",
              "item": "https://eximon.com/features"
            }
          ]
        }
      ]
    })}
  </script>
        </Helmet>
)}
        <div className="container">
          <div className="section-title">
            <h1>Features</h1>
          </div>

          <div className="row">
            {features.length > 0
              ? features.map((d, i) => (
                  <div key={`${d.title}-${i}`} className="col-xs-6 col-sm-4 col-md-3">
                    <div className="thumbnail feature-card text-center" style={{ padding: "20px" }}>

                      <i className={d.icon} style={{ fontSize: "32px", marginBottom: "10px" }}></i>
                      <h4>
                        <button
                          type="button"
                          onClick={() => {
                            if (d.video) {
                              setVideoUrl(d.video);
                              setShowModal(true);
                            }
                            else if (d.link) {
                              window.document.getElementById(d.link.replace("#", ""))?.scrollIntoView({
                                behavior: "smooth",
                              });
                            }
                          }}
                          style={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            background: "none",
                            border: "none",
                            padding: 0,
                            textAlign: "left",
                          }}
                        >
                          {d.title}
                        </button>
                      </h4>
                      {/* <h4>
                        <a
                          href={d.video ? undefined : d.link}
                          role={d.video ? "button" : undefined}
                          style={{ fontWeight: "bold", cursor: "pointer" }}
                          onClick={(e) => {
                            if (d.video) {
                              e.preventDefault();
                              setVideoUrl(d.video);
                              setShowModal(true);
                            }
                          }}
                        >
                          {d.title}
                        </a>

                      </h4> */}

                      <div
                        className="card-text"
                        dangerouslySetInnerHTML={{
                          __html:
                            d.text && d.text.trim() !== "" ? d.text : featureDetails[d.title] || "Details coming soon."
                        }}
                      />
                    </div>
                  </div>
                ))
                : "No data available"}
          </div>
        </div>

      </div>
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
              maxWidth: "800px",
              width: "90%"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <video
              src={videoUrl}
              controls
              autoPlay
              style={{ width: "100%", borderRadius: "8px" }}
            />

            <button
              style={{
                marginTop: "10px",
                padding: "8px 16px",
                background: "#333",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer"
              }}
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};
